export class QuoteViewModel {
    FullName: string;
    CompanyName: string;
    Email: string;
    Phone: string;
    Reason: string;
    Deadline: string;
    Description: string;
}